import React from "react";
import {Controller} from "react-hook-form";
import {Checkbox, FormControlLabel} from "@mui/material";

export default function ReactHookFormCheckbox(
    {
        name, label, labelPlacement, control,
        updateOnChange = () => null,
        defaultValue = false
    }
) {
    const labelId = `${name}-label`;
    return (
        <FormControlLabel
            control={
                <Controller
                    name={name}
                    defaultValue={defaultValue}
                    render={({field: {onChange, value, ...props}}) =>
                        <Checkbox
                            color="primary"
                            checked={value === true}
                            onChange={(e, data) => {
                                onChange(data);
                                updateOnChange();
                            }}
                            {...props}
                        />
                    }
                    control={control}
                />
            }
            id={labelId}
            label={label}
            labelPlacement={labelPlacement}
        />
    );
}
